// Mock data de vehículos — marcas, modelos y ciudades de Colombia

export const MOCK_VEHICLE_BRANDS = [
  {
    id: 'chevrolet',
    name: 'Chevrolet',
    models: [
      { id: 'spark', name: 'Spark', brandId: 'chevrolet' },
      { id: 'onix', name: 'Onix', brandId: 'chevrolet' },
      { id: 'tracker', name: 'Tracker', brandId: 'chevrolet' },
      { id: 'equinox', name: 'Equinox', brandId: 'chevrolet' },
      { id: 'colorado', name: 'Colorado', brandId: 'chevrolet' },
    ],
  },
  {
    id: 'toyota',
    name: 'Toyota',
    models: [
      { id: 'corolla', name: 'Corolla', brandId: 'toyota' },
      { id: 'hilux', name: 'Hilux', brandId: 'toyota' },
      { id: 'rav4', name: 'RAV4', brandId: 'toyota' },
      { id: 'yaris', name: 'Yaris', brandId: 'toyota' },
      { id: 'fortuner', name: 'Fortuner', brandId: 'toyota' },
    ],
  },
  {
    id: 'renault',
    name: 'Renault',
    models: [
      { id: 'logan', name: 'Logan', brandId: 'renault' },
      { id: 'sandero', name: 'Sandero', brandId: 'renault' },
      { id: 'duster', name: 'Duster', brandId: 'renault' },
      { id: 'kwid', name: 'Kwid', brandId: 'renault' },
      { id: 'stepway', name: 'Stepway', brandId: 'renault' },
    ],
  },
  {
    id: 'mazda',
    name: 'Mazda',
    models: [
      { id: 'mazda2', name: 'Mazda2', brandId: 'mazda' },
      { id: 'mazda3', name: 'Mazda3', brandId: 'mazda' },
      { id: 'cx3', name: 'CX-3', brandId: 'mazda' },
      { id: 'cx5', name: 'CX-5', brandId: 'mazda' },
      { id: 'bt50', name: 'BT-50', brandId: 'mazda' },
    ],
  },
  {
    id: 'kia',
    name: 'KIA',
    models: [
      { id: 'picanto', name: 'Picanto', brandId: 'kia' },
      { id: 'rio', name: 'Rio', brandId: 'kia' },
      { id: 'sportage', name: 'Sportage', brandId: 'kia' },
      { id: 'sorento', name: 'Sorento', brandId: 'kia' },
      { id: 'seltos', name: 'Seltos', brandId: 'kia' },
    ],
  },
  {
    id: 'hyundai',
    name: 'Hyundai',
    models: [
      { id: 'tucson', name: 'Tucson', brandId: 'hyundai' },
      { id: 'elantra', name: 'Elantra', brandId: 'hyundai' },
      { id: 'accent', name: 'Accent', brandId: 'hyundai' },
      { id: 'creta', name: 'Creta', brandId: 'hyundai' },
      { id: 'santa-fe', name: 'Santa Fe', brandId: 'hyundai' },
    ],
  },
  {
    id: 'volkswagen',
    name: 'Volkswagen',
    models: [
      { id: 'polo', name: 'Polo', brandId: 'volkswagen' },
      { id: 'golf', name: 'Golf', brandId: 'volkswagen' },
      { id: 'tiguan', name: 'Tiguan', brandId: 'volkswagen' },
      { id: 'jetta', name: 'Jetta', brandId: 'volkswagen' },
      { id: 'amarok', name: 'Amarok', brandId: 'volkswagen' },
    ],
  },
  {
    id: 'ford',
    name: 'Ford',
    models: [
      { id: 'fiesta', name: 'Fiesta', brandId: 'ford' },
      { id: 'focus', name: 'Focus', brandId: 'ford' },
      { id: 'escape', name: 'Escape', brandId: 'ford' },
      { id: 'ranger', name: 'Ranger', brandId: 'ford' },
      { id: 'explorer', name: 'Explorer', brandId: 'ford' },
    ],
  },
  {
    id: 'nissan',
    name: 'Nissan',
    models: [
      { id: 'versa', name: 'Versa', brandId: 'nissan' },
      { id: 'sentra', name: 'Sentra', brandId: 'nissan' },
      { id: 'kicks', name: 'Kicks', brandId: 'nissan' },
      { id: 'qashqai', name: 'Qashqai', brandId: 'nissan' },
      { id: 'navara', name: 'Navara', brandId: 'nissan' },
    ],
  },
  {
    id: 'suzuki',
    name: 'Suzuki',
    models: [
      { id: 'alto', name: 'Alto', brandId: 'suzuki' },
      { id: 'swift', name: 'Swift', brandId: 'suzuki' },
      { id: 'vitara', name: 'Vitara', brandId: 'suzuki' },
      { id: 'grand-vitara', name: 'Grand Vitara', brandId: 'suzuki' },
      { id: 'jimny', name: 'Jimny', brandId: 'suzuki' },
    ],
  },
];

export const MOCK_VEHICLE_YEARS: number[] = Array.from(
  { length: 12 },
  (_, i) => 2026 - i,
);

export const MOCK_CITIES = [
  { id: 'bogota', name: 'Bogotá D.C.', region: 'Cundinamarca' },
  { id: 'medellin', name: 'Medellín', region: 'Antioquia' },
  { id: 'cali', name: 'Cali', region: 'Valle del Cauca' },
  { id: 'barranquilla', name: 'Barranquilla', region: 'Atlántico' },
  { id: 'cartagena', name: 'Cartagena', region: 'Bolívar' },
  { id: 'cucuta', name: 'Cúcuta', region: 'Norte de Santander' },
  { id: 'bucaramanga', name: 'Bucaramanga', region: 'Santander' },
  { id: 'ibague', name: 'Ibagué', region: 'Tolima' },
  { id: 'pereira', name: 'Pereira', region: 'Risaralda' },
  { id: 'manizales', name: 'Manizales', region: 'Caldas' },
  { id: 'pasto', name: 'Pasto', region: 'Nariño' },
  { id: 'neiva', name: 'Neiva', region: 'Huila' },
  { id: 'villavicencio', name: 'Villavicencio', region: 'Meta' },
  { id: 'armenia', name: 'Armenia', region: 'Quindío' },
  { id: 'monteria', name: 'Montería', region: 'Córdoba' },
];
